import { ModulesTypes } from "constants/features"
import { Module, ModuleAdapted, Submodule } from "./index"
import { LANGUAGES } from "../../constants/language"

export const mapSubmoduleToPrivateRoute = (module: ModulesTypes) => (
	submodule: Submodule
): ModuleAdapted => ({
	module,
	submodule: submodule.module,
	component: submodule.component,
	path: submodule.path,
	policies: submodule.policies,
	isNewModule: submodule.isNewModule,
	startDate: submodule.startDate,
	endDate: submodule.endDate,
	languages: submodule.languages || LANGUAGES,
})

export const reduceModuleToPrivateRoute = (
	acc: Array<ModuleAdapted>,
	module: Module
): Array<ModuleAdapted> => {
	const { submodules = [], ...restModule } = module
	const isRenderModuleRouter = !!module.component && !!module.path

	const submodulesAdapted: Array<ModuleAdapted> = submodules.map(
		mapSubmoduleToPrivateRoute(module.module)
	)

	if (isRenderModuleRouter) {
		return [restModule, ...submodulesAdapted, ...acc]
	}

	return [...submodulesAdapted, ...acc]
}
